import {
  useCancelDataRequestMutation,
  useCancelOpenBankingRequestMutation,
} from '@/lib/apollo'
import { RequestType } from '@/types/Recommendation'

interface UseCancelRequestProps {
  applicationId: string
  customerId: string
  subjectId: string
  recommendationId: string
  requestType: RequestType
  userId?: string
  onCancelled?: () => void
}

interface UseCancelRequestReturn {
  loading: boolean
  error: any
  cancelRequest: (notifyApplicant: boolean) => void
  requestTypeText: string
}

export const useCancelRequest = ({
  applicationId,
  customerId,
  subjectId,
  recommendationId,
  requestType,
  userId,
  onCancelled,
}: UseCancelRequestProps): UseCancelRequestReturn => {
  const [
    performCancelOpenBankingRequest,
    { loading: openBankingRequestLoading, error: openBankingRequestError },
  ] = useCancelOpenBankingRequestMutation()
  const [
    performCancelDataRequest,
    { loading: payrollRequestLoading, error: payrollRequestError },
  ] = useCancelDataRequestMutation()

  const isOpenBanking = requestType === RequestType.OPEN_BANKING
  const loading = isOpenBanking ? openBankingRequestLoading : payrollRequestLoading
  const error = isOpenBanking ? openBankingRequestError : payrollRequestError

  const requestTypeText = isOpenBanking ? 'Open Banking' : 'Payroll/HMRC'

  const cancelRequest = (notifyApplicant: boolean) => {
    if (isOpenBanking) {
      performCancelOpenBankingRequest({
        variables: {
          applicationId,
          customerId,
          subjectId,
          recommendationId,
          notifyApplicant,
        },
        onCompleted: () => {
          onCancelled?.()
        },
      })
    } else {
      performCancelDataRequest({
        variables: {
          customerId,
          subjectId,
          userId: userId ?? '',
          recommendationId,
          recommendationType: 'PayrollRecommendation',
          notifyApplicant,
        },
        onCompleted: () => {
          onCancelled?.()
        },
      })
    }
  }

  return {
    loading,
    error,
    cancelRequest,
    requestTypeText,
  }
}
